<template>
  <div>
    <div class="container" style="margin: 0;padding: 0;width: 100px;border-radius: 4px; border: 1px solid lightgray;position: relative;">
      <div class="text-center" style="position: absolute;width: 100%; height: 100%; top: 0; left:0;z-index: 10;">
      <span class="small">{{ thisvalue }} / {{ thismax }}</span>
      </div>
      <div :id="thisid" :class="thisvariant" class="progressinitial"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SurveyProgressBar',
  props: [
    'survey_id',
    'progressvalue',
    'progressmax',
    'progressvariant'
  ],
  mounted() {
    this.setprogress();
  },
  data() {
    return {
      thisid: this.survey_id,
      thisvalue: parseInt(this.progressvalue),
      thismax: parseInt(this.progressmax),
      thisvariant: this.progressvariant
    }
  },
  methods: {
    setprogress: function() {
      var elem = document.getElementById(this.thisid);
      var max = this.thismax;
      var value = this.thisvalue;
      var percentvalue = ((value/max)*100).toFixed(0);
      var bounce = 5;
      var bouncepercent = parseInt(percentvalue) + bounce;
      var width = 1;
      var id = setInterval(frame, 20);
      function frame() {
        if (width >= bouncepercent) {
          clearInterval(id);
          var bint = setInterval(function() {
            if (width <= percentvalue-bounce) {
              var bint2 = setInterval(function() {
                if (width >= percentvalue) {
                  clearInterval(bint2);
                } else {
                  width++;
                  elem.style.width = width + 'px';
                }
              },10);
              clearInterval(bint);
            } else {
              width--;
              elem.style.width = width + 'px';
            }
          },10);
        } else {
          width++;
          elem.style.width = width + 'px';
        }
      }
    }
  }
}
</script>
<style>
.progressinitial {
  width: 1px;
  height: 28px;
  /* -webkit-transition: width 6s; *//* For Safari 3.1 to 6.0 */
  /* transition: width 6s; */
}
</style>
